import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Stack } from '@mui/material';

import { i18nNS } from '../../../i18n';
import { TileDrawerButton, TileDrawerCheckbox } from '../styles';
import useTileIntroductionForm, { UseTileIntroductionForm } from './vm';

export interface TileIntroductionFormProps extends UseTileIntroductionForm {
  className?: string;
  children: ReactNode;
}

const TileIntroductionForm = ({ className, children, ...vmProps }: TileIntroductionFormProps) => {
  const { t } = useTranslation([i18nNS.SHARED]);

  const { formMethods, onSubmit, onClose } = useTileIntroductionForm(vmProps);
  const { handleSubmit, control, formState } = formMethods;
  const { isSubmitting } = formState;

  return (
    <Stack gap={2} component="form" noValidate onSubmit={handleSubmit(onSubmit)} className={className}>
      <Box flex={1}>{children}</Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" component="footer">
        <TileDrawerCheckbox
          control={control}
          name="doNotShowAgain"
          label={t('do_not_show_again', { ns: i18nNS.SHARED })}
        />
        <Stack direction="row" alignItems="center" gap={2}>
          <TileDrawerButton type="button" variant="text" onClick={onClose}>
            {t('cancel', { ns: i18nNS.GLOSSARY })}
          </TileDrawerButton>
          <TileDrawerButton type="submit" isLoading={isSubmitting}>
            {t('next', { ns: i18nNS.GLOSSARY })}
          </TileDrawerButton>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TileIntroductionForm;
